export default "__VITE_ASSET__BGlGfy0Q__"